import { FC } from 'react';
import './NoteInfo.scss';
import SectionLayout from 'atoms/components/SectionLayout';
import { useTranslation } from 'react-i18next';

const NoteInfo: FC = () => {
  const { t } = useTranslation();

  return (
    <SectionLayout
      type="right"
      header={<span className="title">{t('Note Information')}</span>}
    >
      <></>
    </SectionLayout>
  );
};

export default NoteInfo;
